export const SCREENS = {
  LIST: "list",
  CHAT_ROOM: "chatRoom",
  SETTINGS: "settings",
  BLOCKED: "blocked",
};

export const FILE_SIZE_LIMIT = {
  PER_FILE: 10 * 1024 * 1024,
  TOTAL: 500 * 1024 * 1024,
};

export const MESSAGE_NACK_CODE = {
  USER_BLOCKED: "USER_BLOCKED",
  BLOCKED_BY_USER: "BLOCKED_BY_USER",
  ROOM_ACCESS_DENIED: "ROOM_ACCESS_DENIED",
  INVALID_REQUEST: "INVALID_REQUEST",
  MESSAGE_SEND_FAILED: "MESSAGE_SEND_FAILED",
};

export const BLOCK_UPDATE_CODE = {
  USER_BLOCKED: "USER_BLOCKED",
  BLOCKED_BY_USER: "BLOCKED_BY_USER",
  USER_UNBLOCKED: "USER_UNBLOCKED",
  UNBLOCKED_BY_USER: "UNBLOCKED_BY_USER",
};

export const MESSAGE_SEND_ERROR = {
  DEFAULT: "메세지 전송에 실패했습니다",
  USER_BLOCKED: "차단한 사용자에게 메시지를 보낼 수 없습니다.",
  BLOCKED_BY_USER: "상대방이 나를 차단하여 메시지를 보낼 수 없습니다.",
  ROOM_ACCESS_DENIED: "채팅방에 접근할 수 없습니다.",
  INVALID_REQUEST: "잘못된 요청입니다.",
  MESSAGE_TOO_LONG: "메세지를 500자 이내로 작성해주세요.",
  FILE_TOO_LARGE: "10MB 이하의 파일만 전송할 수 있습니다",
  FILE_TOO_LARGE_TOTAL: "파일 전체 용량은 500MB 로 제한됩니다.",
};
